import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/Slice/authSlice";
import { ROLE_LABELS } from "../utils/format";
import { returnToMyAccount, viewingAsBy } from "../utils/viewAs";

// Shown on every page while a Super Admin is viewing the panel as someone else
export default function ViewAsBanner() {
  const user = useSelector(selectUser);
  const by = viewingAsBy();
  if (!user || !by) return null;
  return (
    <div className="view-as-banner" role="status">
      <span className="view-as-eye" aria-hidden="true">👁</span>
      <span className="view-as-text">
        Viewing as <b>{user.name}</b> <em>{ROLE_LABELS[user.role]}</em>
      </span>
      <button type="button" onClick={returnToMyAccount}>Back to my account</button>
    </div>
  );
}
